<template>
  <div v-show="show" :class="['silder', full && 'full']">
    <div class="header">
      <span class="iconfont iconpre actable" @click.prevent="switchfull"></span>
      <div class="title">
        <h1>
          {{ title }}
        </h1>
        <h2>{{ magname }}</h2>
        <span>{{ issueno }}期</span>
      </div>
    </div>
    <div class="htmlcontent">
      <iframe id="html" width="100%" frameborder="0" height="100%" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: { type: Boolean, default: false },
    hcontent: { type: String, default: "" },
    title: { type: String, default: "" },
    magname: { type: String, default: "" },
    issueno: { type: String, default: "" },
  },
  data() {
    return { full: false };
  },
  methods: {
    loadData() {
      if (this.show && this.hcontent.length > 0) {
        const o = document.getElementById("html");
        const doc = o.contentWindow.document || o.contentDocument;
        doc.open("text/html", "replace");
        doc.write(this.hcontent);
        doc.close();
        doc.contentEditable = true;
        doc.designMode = "on";
      }
    },
    switchfull() {
      this.full = !this.full;
    },
  },
  watch: {
    hcontent(newval) {
      if (newval) this.loadData();
    },
  },
};
</script>

<style scoped>
.silder {
  position: fixed;
  right: 0;
  bottom: 0;
  height: 100vh;
  margin-bottom: -90vh;
  left: 0;
  background-color: #fff;
  overflow: hidden;
  border-radius: 0.5rem 0.5rem 0 0;
  outline: none;
  box-shadow: 0px 0px 5px 0px rgba(132, 132, 132, 0.5);
  z-index: 11;
  transition: all 0.3s ease-in;
}

.header {
  /* fix ie display diff */
  height: 1rem;
  text-align: center;
}

.full .header {
  height: 0.5rem;
}

.title {
  text-align: left;
  padding-left: 1.14rem;
}

.title * {
  display: inline-block;
  margin: 0;
  margin-right: 0.1rem;
  height: 0.35rem;
}

.title H1 {
  font-size: 0.33rem;
  /* line-height: 0.35rem; */
}

.title h2,
.title span {
  font-size: 0.2rem;
  /* line-height: 0.2rem; */
}

.title span {
  color: #1260ab;
}

@keyframes silderup {
  0% {
    margin-bottom: -60vh;
  }
  100% {
    margin-bottom: 0;
  }
}

.full {
  animation: silderup 0.3s;
  margin-bottom: 0;
  /* height: 100vh; */
  /* transition: all 0.3s ease-out; */
}

.full .iconpre {
  transform: rotate(-90deg);
}

.full .htmlcontent {
  /* visibility: visible; */
}

.htmlcontent {
  height: 96vh;
  margin-bottom: 4vh;
  /* visibility: hidden; */
}
.iconfont {
  font-size: 0.24rem;
  color: #777777;
}

.slide-fade-enter-active {
  transition: all 0.3s ease-in;
}
.slide-fade-leave-active {
  transition: all 0.3s ease-out;
  /* cubic-bezier(1, 0.5, 0.8, 1); */
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translatey(10px);
  /* opacity: 0; */
}

.iconpre {
  display: inline-block;
  transform: rotate(90deg);
  font-size: 0.25rem;
  margin: 0.1rem 0;
}
</style>